import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Calendar, Users, Search } from 'lucide-react';
import Button from '../UI/Button';

const BookingCheckForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const [formData, setFormData] = useState({
    checkIn: '',
    checkOut: '',
    guests: 2
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Navigate to booking page with form data as URL parameters
    const searchParams = new URLSearchParams({
      checkIn: formData.checkIn,
      checkOut: formData.checkOut,
      guests: formData.guests
    });
    
    navigate(`/booking?${searchParams.toString()}`);
  };

  // Get today's date for min attribute
  const today = new Date().toISOString().split('T')[0];

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Check-in Date */}
        <div className="space-y-2">
          <label className="block text-sm font-sofia font-medium text-gray-700">
            <Calendar className="inline w-4 h-4 mr-2" />
            {t('booking.checkIn')}
          </label>
          <input
            type="date"
            name="checkIn"
            value={formData.checkIn}
            onChange={handleInputChange}
            min={today}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent focus:border-accent transition-all duration-300 font-sofia"
          />
        </div>

        {/* Check-out Date */}
        <div className="space-y-2">
          <label className="block text-sm font-sofia font-medium text-gray-700">
            <Calendar className="inline w-4 h-4 mr-2" />
            {t('booking.checkOut')}
          </label>
          <input
            type="date"
            name="checkOut"
            value={formData.checkOut}
            onChange={handleInputChange}
            min={formData.checkIn || today}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent focus:border-accent transition-all duration-300 font-sofia"
          />
        </div>

        {/* Guests */}
        <div className="space-y-2">
          <label className="block text-sm font-sofia font-medium text-gray-700">
            <Users className="inline w-4 h-4 mr-2" />
            {t('booking.guests')}
          </label>
          <select
            name="guests"
            value={formData.guests}
            onChange={handleInputChange}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent focus:border-accent transition-all duration-300 font-sofia"
          >
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => (
              <option key={num} value={num}>
                {num} {num === 1 ? t('common.guest') : t('common.guests')}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Submit Button */}
      <div className="text-center pt-4">
        <Button
          type="submit"
          size="lg"
          className="bg-[#81736d] hover:bg-[#81736d]/90 text-white px-8 py-3 rounded-lg font-sofia font-medium transition-all duration-300 hover:shadow-lg"
        >
          <Search className="inline w-5 h-5 mr-2" />
          {t('booking.checkAvailability')}
        </Button>
      </div>
    </form>
  );
};

export default BookingCheckForm;
